export default {
  scratch_beginner_2020_september: {
    course_id: 'scratch_beginner',
    month: 'September',
    time: '4:00pm - 5:30pm',
    day: 'Mondays',
    details: '9/14, 9/21, 9/28, 10/05',
    ordinal: 0,
    done: true,
  },
  scratch_beginner_2020_october: {
    course_id: 'scratch_beginner',
    month: 'October',
    time: '4:00pm - 5:30pm',
    day: 'Mondays',
    details: '10/12, 10/19, 10/26, 11/02',
    ordinal: 1,
    done: true,
  },
  scratch_beginner_2020_november: {
    course_id: 'scratch_beginner',
    month: 'November',
    time: '4:00pm - 5:30pm',
    day: 'Mondays',
    details: '11/09, 11/16, 11/30, 12/07',
    ordinal: 2,
    done: true,
  },
  scratch_beginner_2020_2_september: {
    course_id: 'scratch_beginner',
    month: 'September',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '9/14, 9/21, 9/28, 10/05',
    ordinal: 0,
    done: true,
  },
  scratch_beginner_2020_2_october: {
    course_id: 'scratch_beginner',
    month: 'October',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '10/12, 10/19, 10/26, 11/02',
    ordinal: 1,
    done: true,
  },
  scratch_beginner_2020_2_november: {
    course_id: 'scratch_beginner',
    month: 'November',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '11/09, 11/16, 11/30, 12/07',
    ordinal: 2,
    done: true,
  },
  scratch_advanced_2020_september: {
    course_id: 'scratch_advanced',
    month: 'September',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '9/14, 9/21, 9/28, 10/05',
    ordinal: 0,
    done: true,
  },
  scratch_advanced_2020_october: {
    course_id: 'scratch_advanced',
    month: 'October',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '10/12, 10/19, 10/26, 11/02',
    ordinal: 1,
    done: true,
  },
  scratch_advanced_2020_november: {
    course_id: 'scratch_advanced',
    month: 'November',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '11/09, 11/16, 11/30, 12/07',
    ordinal: 2,
    done: true,
  },
  web_dev_beginner_2020_september: {
    course_id: 'web_dev_beginner',
    month: 'September',
    time: '4:00pm - 5:30pm',
    day: 'Mondays',
    details: '9/14, 9/21, 9/28, 10/05',
    ordinal: 0,
    done: true,
  },
  web_dev_beginner_2020_october: {
    course_id: 'web_dev_beginner',
    month: 'October',
    time: '4:00pm - 5:30pm',
    day: 'Mondays',
    details: '10/12, 10/19, 10/26, 11/02',
    ordinal: 1,
    done: true,
  },
  web_dev_beginner_2020_november: {
    course_id: 'web_dev_beginner',
    month: 'November',
    time: '4:00pm - 5:30pm',
    day: 'Mondays',
    details: '11/09, 11/16, 11/30, 12/07',
    ordinal: 2,
    done: true,
  },
  web_dev_intermediate_2020_september: {
    course_id: 'web_dev_intermediate',
    month: 'September',
    time: '5:45pm - 7:15pm',
    day: 'Wednesdays',
    details: '9/16, 9/23, 9/30, 10/07',
    ordinal: 0,
    done: true,
  },
  web_dev_intermediate_2020_october: {
    course_id: 'web_dev_intermediate',
    month: 'October',
    time: '5:45pm - 7:15pm',
    day: 'Wednesdays',
    details: '10/14, 10/21, 10/28, 11/04',
    ordinal: 1,
    done: true,
  },
  web_dev_intermediate_2020_november: {
    course_id: 'web_dev_intermediate',
    month: 'November',
    time: '5:45pm - 7:15pm',
    day: 'Wednesdays',
    details: '11/11, 11/18, 12/02, 12/09',
    ordinal: 2,
    done: true,
  },
  python_2020_september: {
    course_id: 'python',
    month: 'September',
    time: '5:45pm - 7:15pm',
    day: 'Tuesdays',
    details: '9/15, 9/22, 9/29, 10/06',
    ordinal: 0,
    done: true,
  },
  python_2020_october: {
    course_id: 'python',
    month: 'October',
    time: '5:45pm - 7:15pm',
    day: 'Tuesdays',
    details: '10/13, 10/20, 10/27, 11/03',
    ordinal: 1,
    done: true,
  },
  python_2020_november: {
    course_id: 'python',
    month: 'November',
    time: '5:45pm - 7:15pm',
    day: 'Tuesdays',
    details: '11/10, 11/17, 12/01, 12/08',
    ordinal: 2,
    done: true,
  },
  next_level_2020_september: {
    course_id: 'next_level',
    month: 'September',
    time: '5:45pm - 7:15pm',
    day: 'Tuesdays',
    details: '9/15, 9/22, 9/29, 10/06',
    ordinal: 0,
    done: true,
  },
  next_level_2020_october: {
    course_id: 'next_level',
    month: 'October',
    time: '5:45pm - 7:15pm',
    day: 'Tuesdays',
    details: '10/13, 10/20, 10/27, 11/03',
    ordinal: 1,
    done: true,
  },
  next_level_2020_november: {
    course_id: 'next_level',
    month: 'November',
    time: '5:45pm - 7:15pm',
    day: 'Tuesdays',
    details: '11/10, 11/17, 12/01, 12/08',
    ordinal: 2,
    done: true,
  },
  scratch_beginner_2021_february: {
    course_id: 'scratch_beginner',
    month: 'February',
    time: '4:00pm - 5:30pm',
    day: 'Mondays',
    details: '2/1, 2/8, 2/22, 3/1',
    ordinal: 0,
    done: true,
  },
  scratch_beginner_2021_march: {
    course_id: 'scratch_beginner',
    month: 'March',
    time: '4:00pm - 5:30pm',
    day: 'Mondays',
    details: '3/8, 3/15, 3/22, 3/29',
    ordinal: 1,
    done: true,
  },
  scratch_beginner_2021_april: {
    course_id: 'scratch_beginner',
    month: 'April',
    time: '4:00pm - 5:30pm',
    day: 'Mondays',
    details: '4/12, 4/19, 4/26, 5/3',
    ordinal: 2,
    done: true,
  },
  scratch_beginner_2021_2_february: {
    course_id: 'scratch_beginner',
    month: 'February',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '2/1, 2/8, 2/22, 3/1',
    ordinal: 0,
    done: true,
  },
  scratch_beginner_2021_2_march: {
    course_id: 'scratch_beginner',
    month: 'March',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '3/8, 3/15, 3/22, 3/29',
    ordinal: 1,
    done: true,
  },
  scratch_beginner_2021_2_april: {
    course_id: 'scratch_beginner',
    month: 'April',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '4/12, 4/19, 4/26, 5/3',
    ordinal: 2,
    done: false,
  },
  arcade_2021_february: {
    course_id: 'arcade',
    month: 'February',
    time: '5:45pm - 7:15pm',
    day: 'Tuesdays',
    details: '2/2, 2/9, 2/23, 3/2',
    ordinal: 0,
    done: true,
  },
  arcade_2021_march: {
    course_id: 'arcade',
    month: 'March',
    time: '5:45pm - 7:15pm',
    day: 'Tuesdays',
    details: '3/9, 3/16, 3/23, 3/30',
    ordinal: 1,
    done: true,
  },
  arcade_2021_april: {
    course_id: 'arcade',
    month: 'April',
    time: '5:45pm - 7:15pm',
    day: 'Tuesdays',
    details: '4/13, 4/20, 4/27, 5/4',
    ordinal: 2,
    done: false,
  },
  scratch_advanced_2021_february: {
    course_id: 'scratch_advanced',
    month: 'February',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '2/1, 2/8, 2/22, 3/1',
    ordinal: 0,
    done: true,
  },
  scratch_advanced_2021_march: {
    course_id: 'scratch_advanced',
    month: 'March',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '3/8, 3/15, ,3/22, 3/29',
    ordinal: 1,
    done: true,
  },
  scratch_advanced_2021_april: {
    course_id: 'scratch_advanced',
    month: 'April',
    time: '5:45pm - 7:15pm',
    day: 'Mondays',
    details: '4/12, 4/19, 4/26, 5/3',
    ordinal: 2,
    done: false,
  },
}